import React, { useState } from 'react';
import { NotificationManager } from 'react-notifications';
import { useDispatch, useSelector } from 'react-redux';

import IconContainer from '@/components/common-components/FtuxComponent/IconContainer';
import ArrowRight from '@/components/Icons/icons/ArrowRight';
import CircleTick from '@/components/Icons/icons/CircleTick';
import SupportIcon from '@/components/Icons/icons/SupportIcon';

import { fetchUserInfo } from '../../../../redux/user/userActions';
import ButtonComponent from '../../../common-components/ButtonComponent/ButtonComponent';
import ModalComponent from '../../../common-components/ModalComponent/ModalComponent';

import '../styles/litePlan.scss';

import { updateSubscriptionMonthlyPlan, updateSubscriptionQuarterlyPlan } from '@/services/cancellation.service';
import { windowReload } from '@/utils/ts/functions';
import Gleap from 'gleap';

export default function LitePlanModal({ show, setShow, onClose, teamLock = false }) {
  const [showLoading, setShowLoading] = useState(false);
  const { userDetails } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const [quarterly, setQuarterly] = useState(true);

  const lite_plan_points = [
    '200 outreaches per month',
    `Third-party affiliate integrations`,
    'One user account',
    'No social listening',
    'Fast and accessible support',
  ];

  const business_plan_points = [
    'Unlimited users, outreach & management',
    'Built-in affiliate tracking. ',
    'Multiple user account',
    'Post tracking up to 10 influencers',
    'Fast and accessible support',
    'Customer Happiness Manager to ensure success',
    'Chrome extension to save on-demand',
  ];

  const handleSwitchToBusinessPlan = async () => {
    setShowLoading(true);
    const body = {
      ratnaCount: 300, // This indicates business plan
    };

    let response;
    if (quarterly) {
      response = await updateSubscriptionQuarterlyPlan(body);
    } else {
      response = await updateSubscriptionMonthlyPlan(body);
    }

    setShowLoading(false);
    dispatch(fetchUserInfo());
    if (response.status) {
      if (!teamLock) {
        onClose();
      } else {
        windowReload();
      }

      NotificationManager.success('Plan Updated', '', 1000);
    } else {
      NotificationManager.error('Something went wrong', '', 1000);
    }
  };

  return (
    <>
      {/* RATNA */}
      <ModalComponent
        outsideClickClose={false}
        show={show === 'ratna'}
        onClose={onClose}
        width={425}
        style={{ padding: '24px 0px' }}>
        <div className="modal-main-content">
          <div className="center">
            <IconContainer bgColor={'var(--secondary-surface-yellow)'} icon="⚠️" />
          </div>

          <h2 className="mt-6 mb-4">Whoops, you&apos;re out of Ratna!</h2>
          <p className="enter-list-name">
            You&apos;re on the Lite plan. This means you can search and save 100 influencers monthly.
            <br />
            <br />
            We recommend waiting until your billing cycle resets, or upgrading to the Business plan if you are scaling.
            <br />
            <br />
            Want more influencers for a better price?
          </p>
          <div
            className="modal-footer-button-container"
            style={{
              flexDirection: 'column',
              alignItems: 'stretch',
            }}>
            <ButtonComponent
              style={{ flex: 1, padding: '10px' }}
              onClick={() => {
                setShow('plan');
              }}>
              Learn More about Business
              <ArrowRight color={'#FFF'} />
            </ButtonComponent>
            <ButtonComponent
              style={{ flex: 1 }}
              type="submit"
              variant="primary-outline"
              onClick={() => {
                setShow(null);
              }}>
              Stay on Lite
            </ButtonComponent>
            <ContactSupportButton />
          </div>
        </div>
      </ModalComponent>

      {/* Reachouts */}
      <ModalComponent
        outsideClickClose={false}
        show={show === 'reachouts'}
        onClose={onClose}
        width={425}
        style={{ padding: '24px 0px' }}>
        <div className="modal-main-content">
          <div className="center">
            <IconContainer bgColor={'var(--secondary-surface-yellow)'} icon="⚠️" />
          </div>
          <h2 className="mt-6 mb-4">You&apos;ve run out of reachouts!</h2>
          <p className="enter-list-name">
            You&apos;re on the Lite plan. This means you can reach out to 200 influencers per month.
            <br />
            <br />
            You&apos;ve hit that limit with your campaigns. We recommend waiting until your billing cycle resets, or
            upgrading to the Business plan if you are scaling.
            <br />
            <br />
            Want unlimited reachouts?
          </p>
          <div
            className="modal-footer-button-container"
            style={{
              flexDirection: 'column',
              alignItems: 'stretch',
            }}>
            <ButtonComponent
              style={{ flex: 1, padding: '10px' }}
              onClick={() => {
                setShow('plan');
              }}>
              Learn More about Business
              <ArrowRight color={'#FFF'} />
            </ButtonComponent>
            <ButtonComponent
              style={{ flex: 1 }}
              type="submit"
              variant="primary-outline"
              onClick={() => {
                setShow(null);
              }}>
              Stay on Lite
            </ButtonComponent>
            <ContactSupportButton />
          </div>
        </div>
      </ModalComponent>

      {/* Team */}
      <ModalComponent
        outsideClickClose={false}
        show={show === 'team'}
        onClose={onClose}
        width={425}
        style={{ padding: '24px 0px' }}>
        <div className="modal-main-content">
          <div className="center">
            <IconContainer bgColor={'var(--secondary-surface-yellow)'} icon="🔒" />
          </div>
          <h2 className="mt-6 mb-4">You&apos;re on the Lite Plan</h2>
          <p className="enter-list-name">
            This means only the primary user will have access to SARAL.
            <br />
            Upgrade to the Business plan to get access to multiple profiles.
          </p>
          <div
            className="modal-footer-button-container"
            style={{
              flexDirection: 'column',
              alignItems: 'stretch',
            }}>
            <ButtonComponent
              style={{ flex: 1, padding: '10px' }}
              onClick={() => {
                setShow('plan');
              }}>
              Learn More about Business
              <ArrowRight color={'#FFF'} />
            </ButtonComponent>
            <ButtonComponent
              style={{ flex: 1 }}
              type="submit"
              variant="primary-outline"
              onClick={() => {
                if (teamLock) {
                  onClose();
                } else {
                  setShow(null);
                }
              }}>
              Stay on Lite
            </ButtonComponent>
            <ContactSupportButton />
          </div>
        </div>
      </ModalComponent>

      {/* Plan comparison */}
      <ModalComponent
        show={show === 'plan'}
        onClose={onClose}
        width={950}
        outsideClickClose={false}
        style={{ padding: '24px 0px' }}
        bgPadding
        bodyStyle={{ padding: '0px 24px' }}>
        <div className="modal-main-content center" style={{ flexDirection: 'column', gap: '16px' }}>
          <h1 className="plan-comparison__header ">Ready to Scale?</h1>
          <div className="plan-comparison__container">
            <div
              onClick={() => setQuarterly(false)}
              className={`plan-comparison__option cursor-pointer ${quarterly ? 'plan-comparison__option--monthly' : 'plan-comparison__option--quarterly'}`}>
              <p>Monthly</p>
            </div>
            <div
              onClick={() => setQuarterly(true)}
              className={`plan-comparison__option cursor-pointer ${!quarterly ? 'plan-comparison__option--monthly' : 'plan-comparison__option--quarterly'}`}>
              <p>Quarterly</p>
              <span className="plan-comparison__save-badge">Save 20%</span>
            </div>
          </div>
          <div className="plan-comparison__plans">
            <div className="plan-comparison__card" style={{ height: '474px' }}>
              <div className="plan-comparison__card-header" style={{ height: '108px' }}>
                <div className="plan-comparison__card-info">
                  <p style={{ fontSize: '22px', fontWeight: 500 }}>💰 Lite Plan</p>
                  <p>{quarterly ? `$199/mo` : `$249/mo`}</p>
                </div>
                <div className="plan-comparison__card-billing">{quarterly && <p>(billed at $597/qtr)</p>}</div>
              </div>
              <div className="p-6">
                <div className="mb-4">
                  <p className="plan-comparison__card-bottom-header">
                    Your current plan. Not suited for growing influencer programs.
                  </p>
                </div>
                {lite_plan_points.map((point, index) => (
                  <div key={index} className="plan-comparison__item">
                    <div className="plan-comparison__circle-tick">
                      <CircleTick color="var(--icon-disabled)" />
                    </div>
                    <p className="plan-comparison__text">{point}</p>
                  </div>
                ))}
              </div>
            </div>
            <div
              className="plan-comparison__card plan-comparison__card-shadow"
              style={{ position: 'relative', height: '474px' }}>
              <div className="plan-comparison__card-header" style={{ height: '108px' }}>
                <div className="plan-comparison__best-value-chip">📈 Best Value</div>
                <div className="plan-comparison__card-info">
                  <p className="plan-comparison__card-info-head" style={{ fontSize: '22px', fontWeight: 500 }}>
                    💼 Business Plan
                  </p>
                  <p>${quarterly ? `399/mo` : '449/mo'}</p>
                </div>
                <div className="plan-comparison__card-billing" style={{ fontSize: '12px' }}>
                  {quarterly && <p>(billed at $1197/qtr)</p>}
                </div>
              </div>
              <div className="p-6">
                <div className="mb-4">
                  <p className="plan-comparison__card-bottom-header">
                    Best suited if you&apos;re looking to scale your program
                  </p>
                </div>
                {business_plan_points.map((point, index) => (
                  <div key={index} className="plan-comparison__item">
                    <div className="plan-comparison__circle-tick">
                      <CircleTick color="var(--success-g-500)" />
                    </div>
                    <p className="plan-comparison__text">{point}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="center gap-6 w-full">
            <div className="w-full">
              <ButtonComponent
                style={{ flex: 1, height: '42px', width: '100%' }}
                type="submit"
                variant="secondary-outline"
                onClick={() => {
                  if (teamLock) {
                    onClose();
                  } else {
                    setShow(null);
                  }
                }}>
                Stay on Lite
              </ButtonComponent>
            </div>
            <div className="w-full">
              <ButtonComponent
                style={{ flex: 1, width: '100%' }}
                showLoading={showLoading}
                onClick={() => {
                  handleSwitchToBusinessPlan();
                }}>
                Move to Business
                <ArrowRight color={'#FFF'} />
              </ButtonComponent>
            </div>
          </div>
        </div>
      </ModalComponent>
    </>
  );
}

const ContactSupportButton = () => {
  const handleSupportChat = () => {
    Gleap.startConversation();
  };

  return (
    <>
      <div
        className="support-tag center gap-2 underline cursor-pointer"
        onClick={() => {
          handleSupportChat();
        }}>
        <SupportIcon />
        Contact Support
      </div>
    </>
  );
};
